import React, { useState, useEffect, useCallback } from 'react';
import CardItem from '../components/CardItem';
import EditModal from '../components/EditModal';

export default function Archive() {
  const [cards, setCards] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [activeTag, setActiveTag] = useState('');
  const [editCard, setEditCard] = useState(null);

  const fetchCards = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams({ status: 'archived' });
    if (search) params.set('search', search);
    if (activeTag) params.set('tag', activeTag);
    const res = await fetch(`/api/cards?${params}`, { credentials: 'include' });
    const data = await res.json();
    setCards(Array.isArray(data) ? data : []);
    setLoading(false);
  }, [search, activeTag]);

  const fetchTags = useCallback(async () => {
    const res = await fetch('/api/tags', { credentials: 'include' });
    const tagData = await res.json(); setTags(Array.isArray(tagData) ? tagData : []);
  }, []);

  useEffect(() => { fetchCards(); }, [fetchCards]);
  useEffect(() => { fetchTags(); }, [fetchTags]);

  const handleAction = async (card, action) => {
    if (action === 'edit') { setEditCard(card); return; }
    const status = action === 'restore' ? 'active' : 'deleted';
    await fetch(`/api/cards/${card.id}`, {
      method: 'PATCH', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status })
    });
    fetchCards();
  };

  return (
    <div>
      <div className="page-header">
        <h1>Archive</h1>
        <div className="subtitle">{cards.length} archived card{cards.length !== 1 ? 's' : ''} — used in finished projects</div>
      </div>

      <div className="toolbar">
        <input className="search-input" placeholder="Search archive..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {tags.filter(t => t.card_count > 0).length > 0 && (
        <div className="tag-filters">
          <span className={`tag ${!activeTag ? 'active' : ''}`} onClick={() => setActiveTag('')}>All</span>
          {tags.map(t => (
            <span key={t.id} className={`tag ${activeTag === t.name ? 'active' : ''}`} onClick={() => setActiveTag(activeTag === t.name ? '' : t.name)}>{t.name}</span>
          ))}
        </div>
      )}

      {loading ? <div className="spinner" /> : cards.length === 0 ? (
        <div className="empty-state">
          <div className="icon">—</div>
          <h3>Nothing archived yet</h3>
          <p>Cards you archive from The Box will appear here.</p>
        </div>
      ) : (
        <div className="cards-grid">
          {cards.map(card => (
            <CardItem key={card.id} card={card} onAction={handleAction} />
          ))}
        </div>
      )}

      {editCard && (
        <EditModal
          card={editCard}
          onSave={(updated) => { setCards(cards.map(c => c.id === updated.id ? updated : c)); setEditCard(null); }}
          onClose={() => setEditCard(null)}
        />
      )}
    </div>
  );
}
